import { PORTFOLIO_TYPE_CONSTS } from '@modules/edit-preference/components/portfolio/components/add-edit-portfolio-type/add-edit-portfolio-type.fields';

/** Maps portfolio type to album type for navigate-to-back routing */
export const PORTFOLIO_TYPE_TO_ALBUM_TYPE: Record<string, string> = {
  [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC_ALBUM,
  [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]: PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST_SERIES,
  [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]: PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO_SERIES,
  [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.COLLECTION,
};

export const ALBUM_PORTFOLIO_CONSTS = {
  ADD_ALBUM: 'Add Album',
  EDIT_ALBUM: 'Edit Album',
  ADD_PODCAST_SERIES: 'Add Podcast Series',
  EDIT_PODCAST_SERIES: 'Edit Podcast Series',
  ADD_VIDEO_SERIES: 'Add Video Series',
  EDIT_VIDEO_SERIES: 'Edit Video Series',
  ADD_ITEM: 'Add Item',
  EDIT_ITEM: 'Edit Item',
  ADD_COLLECTION: 'Add Collection',
  EDIT_COLLECTION: 'Edit Collection',
  STEP_1_OF_3: 'STEP 1 OF 3',
  STEP_2_OF_3: 'STEP 2 OF 3',
  STEP_3_OF_3: 'STEP 3 OF 3',
  BASIC_INFORMATION: 'Album Information',
  BACK: 'BACK',
  SAVE_AND_CONTINUE: 'SAVE & CONTINUE',
  DISABLE: 'DISABLE',
  ENABLE: 'ENABLE',
  CANCEL: 'CANCEL',
  SAVE_AS_DRAFT: 'SAVE AS DRAFT',
  PUBLISH_ALBUM: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'PUBLISH ALBUM',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]: 'PUBLISH PODCAST SERIES',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]: 'PUBLISH VIDEO SERIES',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: 'PUBLISH COLLECTION'
  },
  UPDATE_ALBUM: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'UPDATE ALBUM',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]: 'UPDATE PODCAST SERIES',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]: 'UPDATE VIDEO SERIES',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.CUSTOM]: 'UPDATE COLLECTION'
  },
  POST_PREVIEW_LABEL: {
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC]: 'Post Preview of Music Album on My Feed',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST]: 'Post Preview of Podcast Series on My Feed',
    [PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO]: 'Post Preview of Video Series on My Feed',
  },
  FAILED_TO_SAVE_ALBUM: 'Failed to save album',
  FAILED_TO_LOAD_ALBUM: 'Failed to load album',
  ALBUM_SAVED_SUCCESS: 'Album saved successfully',
  ALBUM_UPDATED_SUCCESS: 'Album updated successfully',
  ALBUM_PUBLISHED_SUCCESS: 'Album Created successfully',
  SELECT_INTERESTS: 'Select Interests',
  SELECT_INTERESTS_HINT: 'Including interest tags related to your post from the list below or your own custom #tags will help you find new fans who share similar interests.',
  BADGE_GROUPS_HINT: 'If a Group(s) is selected in this list, only users belonging to that Group will see this album.',
  TRUE: 'true',
};

export const getTitleByPortfolioType = (
  portfolioType: string,
  isEdit: boolean = false
): string => {
  const type = portfolioType?.toLowerCase();
  const isMusic = type === PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.MUSIC.toLowerCase();
  const isPodcast = type === PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.PODCAST.toLowerCase();
  const isVideoSeries = type === PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE.VIDEO.toLowerCase();

  if (isMusic) {
    return isEdit ? ALBUM_PORTFOLIO_CONSTS.EDIT_ALBUM : ALBUM_PORTFOLIO_CONSTS.ADD_ALBUM;
  } else if (isPodcast) {
    return isEdit ? ALBUM_PORTFOLIO_CONSTS.EDIT_PODCAST_SERIES : ALBUM_PORTFOLIO_CONSTS.ADD_PODCAST_SERIES;
  } else if (isVideoSeries) {
    return isEdit ? ALBUM_PORTFOLIO_CONSTS.EDIT_VIDEO_SERIES : ALBUM_PORTFOLIO_CONSTS.ADD_VIDEO_SERIES;
  }

  return isEdit ? ALBUM_PORTFOLIO_CONSTS.EDIT_COLLECTION : ALBUM_PORTFOLIO_CONSTS.ADD_COLLECTION;
};

